import styled from "styled-components";

const StyledSubcategory = styled.div`
  display: inline-block;
  padding: 8px 16px;
  border-radius: 32px;
  background-color: #e6e8f0;
  font-size: 14px;
  font-weight: bold;
  line-height: 1.14;
  color: #222939;
  cursor: pointer;
  transition: all 300ms ease-out;
  margin-right: 8px;
  margin-bottom: 8px;

  :hover {
    background-color: ${props => (props.checked ? "#fff" : "#dce0ea")};
  }

  background-color: ${props => (props.checked ? "#fff" : "#e6e8f0")};
  box-shadow: ${props =>
    props.checked ? "0 4px 20px 0 rgba(34, 41, 57, 0.15)" : "unset"};
  position: relative;
  border: ${props =>
    props.checked ? "solid 1px #bab1ff" : "solid 1px transparent;"};
  :before {
    content: " ";
    display: block;
    opacity: ${props => (props.checked ? 1 : 0)};
    position: absolute;
    width: calc(100% + 6px);
    border-radius: 42px;
    top: -3px;
    left: -3px;
    right: -3px;
    bottom: -3px;
    border: 2px solid rgba(186, 177, 255, 0.3);
  }
`;

export { StyledSubcategory };



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/search/subcategories/SubcategoryStyle.js